@for (alert of alerts; track $index) {
  <div
    class="alert-container"
    [class]="cssClass(alert)"
    [animate.enter]="'alert-enter'"
    [animate.leave]="'alert-leave'"
  >
    @if (alert.type === alertType.Notification && alert.notification) {
      <div>
        <app-notification
          class="alert-notification flex"
          [notification]="alert.notification"
          [popupMode]="true"
          (closeNotifications)="removeAlert(alert)"
        />
      </div>
    } @else {
      <svg
        class="alert alert-dismissable svg-24 mr-8"
        [ngClass]="svgIcon(alert).color"
        [svgIcon]="svgIcon(alert).icon"
      ></svg>
      <span [innerHTML]="alert.message"></span>
    }
  </div>
}
